import React, { useState, useEffect, useRef } from "react";
import { makeStyles } from "@material-ui/core";
import greenTimer from "../../assets/images/greenTimer.png";
import redTimer from "../../assets/images/redTimer.png";
import { toast } from "react-toastify";

const useStyles = makeStyles((theme) => ({
  timerRoot: {
    width: "max-content",
    borderRadius: "20px",
    padding: "5px 10px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#FFFFFF",
    fontSize: "12px",
    lineHeight: "18px",
    fontWeight: "500",
  },
  timer: {
    background: "linear-gradient(99.26deg, #F36B4E 0%, #F75624 100%), #FFFFFF",
  },
  timerGreen: {
    background: "#4335A7",
    borderRadius: "32px",
    color: "white",
    minWidth: "103px",
    height: "40px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  timerWorksheet: {
    borderRadius: "32px",
    color: "white",
    minWidth: "103px",
    height: "40px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "linear-gradient(99.26deg, #FF9C00 0%, #FF8101 100%)",
  },
  evaluationTimer: {
    lineHeight: "24px",
    fontSize: "16px",
    fontWeight: 500,
    height: "40px",
    background: "#0000FF",
    padding: "5px 18px",
  },
  warningTimer: {
    background: "#FF0000 !important",
  },
  activeTimeContainer: {
    background: "#DBF0EF",
    borderRadius: "4px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "5px",
    marginTop: "10px",
  },
  completedTimerText: {
    color: "#429F99",
    fontSize: "16px",
  },
  completedTimerTextMaths: {
    fontWeight: 500,
    fontSize: "14px",
    color: "#FFFFFF",
  },
  completedTimerTextMobile: {
    fontSize: "12px",
    fontWeight: 400,
  },
  activeTimeContainerMaths: {
    background: "linear-gradient(99.26deg, #19B933 0%, #13B105 100%), #FFFFFF",
    border: "2px solid #1CD935",
    borderRadius: "20px",
    color: "white",
    padding: "10px",
  },
}));

const AssessmentTimer = ({
  startTime,
  endTime,
  duration,
  restartTimer,
  endAssessment,
  type,
  loading,
}) => {
  const classes = useStyles();
  const calculateSeconds = (time) => {
    const [hours, minutes, seconds] = time.split(":");
    return parseInt(hours) * 3600 + parseInt(minutes) * 60 + parseInt(seconds);
  };

  const [seconds, setSeconds] = useState(calculateSeconds(duration + ":00"));
  const [timeOutput, setTimeOutput] = useState("");
  const warningShownRef = useRef(false);

  const formatTime = (totalSeconds) => {
    const sign = totalSeconds < 0 ? "-" : "";
    const absSeconds = Math.abs(totalSeconds);

    const hours = Math.floor(absSeconds / 3600);
    const minutes = Math.floor((absSeconds % 3600) / 60);
    const seconds = absSeconds % 60;

    const formattedHours = String(hours).padStart(2, "0");
    const formattedMinutes = String(minutes).padStart(2, "0");
    const formattedSeconds = String(seconds).padStart(2, "0");

    return hours === 0 && type === "Evaluation"
      ? `${sign}${formattedMinutes}:${formattedSeconds}`
      : `${sign}${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
  };

  useEffect(() => {
    let intervalId;
    if (!endTime && !restartTimer) {
      intervalId = setInterval(() => {
        setSeconds((prevSeconds) => {
          const updatedSeconds = prevSeconds > 0 ? prevSeconds - 1 : 0;
          return updatedSeconds;
        });
      }, 1000);
    } else if (restartTimer) {
      setSeconds(calculateSeconds(duration + ":00"));
      warningShownRef.current = false; // Reset warning flag on restart
    }
    return () => {
      clearInterval(intervalId);
    };
  }, [duration, endTime, restartTimer]);

  useEffect(() => {
    setTimeOutput(formatTime(seconds));
    if (type === "Evaluation" && seconds === 0) {
      if (loading) return;
      endAssessment({ submit: 1, completed: 0, timeout: 1, quit: 0 });
    } else if (
      type === "Evaluation" &&
      seconds === 60 &&
      !warningShownRef.current
    ) {
      warningShownRef.current = true;
      toast.info("1 more min to go. Keep going!", {
        position: toast.POSITION.TOP_CENTER,

        style: { marginTop: window.ReactNativeWebView ? "28px" : "0px" },
      });
    }
  }, [seconds, loading]);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        margin: "auto",
        position: "relative",
        left: "35px",
      }}
    >
      {!endTime && (
        <div
          className={
            timeOutput.includes("-")
              ? `${classes.timer} ${classes.timerRoot} 
              ${type === "Evaluation" ? classes.evaluationTimer : ""} 
              ${
                type === "Evaluation" && seconds < 60
                  ? classes.warningTimer
                  : ""
              }`
              : type === "worksheet"
              ? `${classes.timerWorksheet} ${classes.timerRoot}`
              : `${classes.timerGreen} ${classes.timerRoot} 
              ${type === "Evaluation" ? classes.evaluationTimer : ""}
               ${
                 type === "Evaluation" && seconds < 60
                   ? classes.warningTimer
                   : ""
               }`
          }
        >
          <img
            src={
              type !== "Evaluation" && timeOutput.includes("-")
                ? redTimer
                : greenTimer
            }
            style={{ marginRight: "5px", height: "16px", width: "16px" }}
            alt={"timer"}
          />
          {timeOutput}
        </div>
      )}
    </div>
  );
};

export default AssessmentTimer;
